import { AnyAction } from 'redux';

import { Order, OrderLegacy } from '@app/crud/apv/order.type';

export const actionTypes = {
    FetchOrders: 'FETCH_ORDERS',
    FetchOrdersLegacy: 'FETCH_ORDERS_LEGACY',
    FetchedOrders: 'FETCHED_ORDERS',
    FetchedOrdersLegacy: 'FETCHED_ORDERS_LEGACY',
    FetchOrder: 'FETCH_ORDER',
    FetchOrderLegacy: 'FETCH_ORDER_LEGACY',
    FetchedOrder: 'FETCHED_ORDER',
    FetchedOrderLegacy: 'FETCHED_ORDER_LEGACY',
    FetchOrdersFailed: 'FETCH_ORDER_FAILED',
    FetchOrderFailed: 'FETCH_ORDER_FAILED',
    SetOrdersTotalRecords: 'SET_ORDERS_TOTALRECORDS',
};

type FiltersContentType = {
    [key: string]: {
        id: number;
        name: string;
        usualName: string;
        refDealership: string;
        slug: string;
        created: string;
        updated: string;
    }[];
};

export interface OrderState {
    loading: boolean;
    orders: OrderLegacy[];
    totalRecords: {
        commande?: number;
        panier?: number;
        draft?: number;
        waiting_for_client?: number;
        closed?: number;
    };
    filtersContent: FiltersContentType;
    order: Order | OrderLegacy | null;
    error: null;
}

const initialState: OrderState = {
    loading: false,
    orders: [],
    totalRecords: {},
    filtersContent: {},
    order: null,
    error: null,
};

export function orderReducer(state = initialState, action: AnyAction) {
    switch (action.type) {
        case actionTypes.FetchOrders:
        case actionTypes.FetchOrdersLegacy:
        case actionTypes.FetchOrderLegacy:
        case actionTypes.FetchOrder: {
            return {
                ...state,
                loading: true,
                order: null,
                error: null,
            };
        }
        case actionTypes.FetchedOrdersLegacy:
        case actionTypes.FetchedOrders: {
            const { orderType } = action.payload;
            return {
                ...state,
                loading: false,
                orders: action.payload.orders,
                totalRecords: {
                    ...state.totalRecords,
                    [orderType]: action.payload.count,
                },
                filtersContent: action.payload.filters,
            };
        }
        case actionTypes.FetchedOrderLegacy:
        case actionTypes.FetchedOrder: {
            return {
                ...state,
                loading: false,
                order: action.payload,
            };
        }
        case actionTypes.FetchOrderFailed:
        case actionTypes.FetchOrdersFailed: {
            return {
                ...state,
                loading: false,
                // @ts-ignore
                orders: [],
                error: action.payload.error,
            };
        }
        case actionTypes.SetOrdersTotalRecords: {
            return {
                ...state,
                totalRecords: action.payload,
            };
        }
        default:
            return state;
    }
}

export const actions = {
    fetchOrdersLegacy: () => ({ type: actionTypes.FetchOrdersLegacy }),
    fetchOrders: () => ({ type: actionTypes.FetchOrders }),
    fetchedOrdersLegacy: (payload: { orderType: string; count: number; orders?: OrderLegacy[]; filters?: object }) => ({
        type: actionTypes.FetchedOrdersLegacy,
        payload,
    }),
    fetchedOrders: (payload: { orderType: string; count: number; orders?: object[]; filters?: object }) => ({
        type: actionTypes.FetchedOrders,
        payload,
    }),
    fetchOrderLegacy: () => ({ type: actionTypes.FetchOrderLegacy }),
    fetchOrder: () => ({ type: actionTypes.FetchOrder }),
    fetchedOrderLegacy: (order: OrderLegacy) => ({ type: actionTypes.FetchedOrderLegacy, payload: order }),
    fetchedOrder: (order: Order) => ({ type: actionTypes.FetchedOrder, payload: order }),
    fetchOrderFailed: (error: object) => ({ type: actionTypes.FetchOrderFailed, payload: error }),
    fetchOrdersFailed: (error: object) => ({ type: actionTypes.FetchOrdersFailed, payload: error }),
    setOrdersTotalRecords: (totalRecords: number) => ({
        type: actionTypes.SetOrdersTotalRecords,
        payload: totalRecords,
    }),
};
